import React, { useState, useEffect } from "react";

export interface Comment {
  comment: string;
}

interface CommentFormProps {
  onSend: (comment: string) => void;
  handleChange: (
    input: string,
  ) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  values: { [key: string]: any };
}

const CommentForm: React.FC<CommentFormProps> = ({
  onSend,
  handleChange,
  values,
}) => {
  const [comment, setComment] = useState<string>(values.comment);

  useEffect(() => {
    onSend(comment);
  }, [comment]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Envoyer les données au parent
  };

  return (
    <form
      onSubmit={(e) => handleSubmit(e)}
      className="max-w-md mx-auto p-8 bg-white rounded"
    >
      <div className="flex mt-5 mb-4 items-center justify-center w-full">
        <label className="block mb-2 w-full">
          Votre commentaire :
          <textarea
            cols={100}
            rows={5}
            className="p-2 border border-gray-300 rounded w-full"
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
              handleChange("comment")(e);
            }}
          />
        </label>
      </div>
    </form>
  );
};

export default CommentForm;
